import { AccountType } from "component-library";
import {
  ALL_OPPORTUNITIES_SEARCH,
  ALL_PAID_SEARCH,
  CLIENT_ALERTS_SEARCH,
  MATCHING_MY_FILTER_SEARCH,
} from "shared/helpers/common";

export enum JobsPageTab {
  MyFilter = "matchingMyFilter",
  AllPaid = "allPaid",
  All = "allOpportunities",
  ClientAlerts = "clientAlerts",
  SelfTapeRequests = "selfTapeRequests",
  MySuggestions = "mySuggestions",
}

export const getFilterSearch = (tab: JobsPageTab) => {
  switch (tab) {
    case JobsPageTab.MyFilter:
      return MATCHING_MY_FILTER_SEARCH;
    case JobsPageTab.All:
      return ALL_OPPORTUNITIES_SEARCH;
    case JobsPageTab.ClientAlerts:
      return CLIENT_ALERTS_SEARCH;
    case JobsPageTab.AllPaid:
      return ALL_PAID_SEARCH;
    default:
      return null;
  }
};

export const userTypeToHiddenTabListMap = {
  [AccountType.Performer]: [JobsPageTab.ClientAlerts],
  [AccountType.Agent]: [JobsPageTab.AllPaid],
} as Record<AccountType, JobsPageTab[]>;

export enum JobsPageBreadcrumb {
  MyAccount = "MyAccount",
}

export const SEARCH_MAX_LENGTH = 100;
